import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-importation-succeed',
  templateUrl: './importation-succeed.component.html',
  styleUrls: ['./importation-succeed.component.scss']
})
export class ImportationSucceedComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<ImportationSucceedComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any[],
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  close() {
    this.router.navigate(['imports']);
    this.dialogRef.close();
  };
}
